import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '常见问答', href: '#faq' },
  { label: '热门话题', href: '#topics' },
  { label: '焦点专题', href: '#carousel' },
  { label: '投稿咨询', href: '#contact' },
  { label: '最新动态', href: '#updates' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#hero');
            }}
            className="flex items-center gap-2 text-foreground-950 no-underline"
          >
            <span className="font-heading text-xl md:text-2xl font-bold tracking-tight text-primary-600">
              布丁漫画
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="relative px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap cursor-pointer group"
              >
                {item.label}
                <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-primary-500 rounded-full transition-all duration-300 group-hover:w-3/5"></span>
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <a
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#cards');
              }}
              className="inline-flex items-center px-4 py-2 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#cards');
              }}
              className="mt-1 mx-3 px-4 py-2.5 text-sm font-medium text-center text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}